import { IconButton, Typography } from '@mui/material';
import { TableV2Column } from 'components/Table/TableV2';
import { AnchorText } from 'components/Text';
import { CandidateBatchGroup } from 'generated-graphql/graphql';
import { Paths } from 'services/navigation/paths';
import { formatDateFromNow, sortByDate } from 'utils/datetime';
import LaunchIcon from '@mui/icons-material/Launch';

export const getRulesetsListColumns = () => {
  const columns: TableV2Column<CandidateBatchGroup>[] = [
    {
      name: 'Ruleset name',
      sortFunction: (a, b) => a.name.localeCompare(b.name),
      sortable: true,
      cell: (row) => (
        <AnchorText
          onClick={() => {
            window.open(`${Paths.ANALYSE_RULESETS}/${row.id}`, '_blank');
          }}
        >
          {row.name}
          <IconButton color="primary">
            <LaunchIcon />
          </IconButton>
        </AnchorText>
      )
    },
    {
      name: 'Last updated',
      cell: (row) => formatDateFromNow(row.updatedAt),
      sortable: true,
      sortFunction: (a, b) => sortByDate(a.updatedAt, b.updatedAt)
    },
    {
      name: 'Created by',
      cell: (row) => <Typography>{row.user?.name || 'Unknown'}</Typography>
    }
  ];

  return columns;
};
